import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiService } from '../services/api';
import type { Crew } from '../types';
import { message } from 'antd';

export const useCrews = () => {
  return useQuery({
    queryKey: ['crews'],
    queryFn: () => apiService.getCrews(),
  });
};

export const useCrew = (id: string | null) => {
  return useQuery({
    queryKey: ['crews', id],
    queryFn: () => apiService.getCrew(id!),
    enabled: !!id,
  });
};

export const useCreateCrew = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (crew: Omit<Crew, 'id'>) => apiService.createCrew(crew),
    onSuccess: () => {
      message.success('Crew created successfully');
      queryClient.invalidateQueries({ queryKey: ['crews'] });
    },
    onError: (error) => {
      message.error('Failed to create crew');
      console.error(error);
    },
  });
};

export const useUpdateCrew = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<Crew> }) =>
      apiService.updateCrew(id, data),
    onSuccess: () => {
      message.success('Crew updated successfully');
      queryClient.invalidateQueries({ queryKey: ['crews'] });
    },
    onError: (error) => {
      message.error('Failed to update crew');
      console.error(error);
    },
  });
};

export const useDeleteCrew = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => apiService.deleteCrew(id),
    onSuccess: () => {
      message.success('Crew deleted successfully');
      queryClient.invalidateQueries({ queryKey: ['crews'] });
    },
    onError: (error) => {
      message.error('Failed to delete crew');
      console.error(error);
    },
  });
};
